import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import {
  getHostelsFormDetails,
  selectHostel,
} from "../../Redux/features/hostelSlice";
import CustomTable2 from "../CustomTable2";
import { hostelBunksCols, hostelBunksRows } from "./utils";

const BunkTable = () => {
  const { gettingRoomBunks, roomBunks, creatingHostelBlock } =
    useAppSelector(selectHostel);
  const dispatch = useAppDispatch();
  const rows = hostelBunksRows(roomBunks, creatingHostelBlock);

  const handlePagination = (value: number) => {
    dispatch(getHostelsFormDetails({ name: "PageNumber", value }));
  };

  const handlePageLimit = (value: number) => {
    dispatch(getHostelsFormDetails({ name: "PageSize", value }));
  };

  return (
    <CustomTable2
      data={{ rows, columns: hostelBunksCols }}
      showPagination={false}
      showHeader={true}
      loading={gettingRoomBunks}
      noRecord={roomBunks?.length === 0}
      page={roomBunks?.currentPage}
      pageCount={roomBunks?.totalRecords}
      pageSize={roomBunks?.pageSize}
      changeLimitHandler={handlePageLimit}
      changePagehandler={handlePagination}
    />
  );
};

export default BunkTable;
